import $ from "jquery";

export default function SmoothScroll() {
}

var allowedTargets = ['#variant-block', '#equipment', '#spare_parts', '#accordion', '#art-detail-page', '#alternatives', '#alternatives2'];

function attachSmoothScroll() {

  $('a[href^="#"]').each(function () {
    var targetId = this.hash;
    var targetAllowed = $.inArray(targetId, allowedTargets) >= 0;
    var noSmoothScroll = $(this).hasClass("js-no-smooth-scroll");

    if (targetAllowed && !noSmoothScroll) {
      $(this).on('click', function (e) {
        var anchor = this.hash;
        var target = $(anchor);

        if (target != undefined && target.offset() != undefined) {
          $('html, body').stop().animate({
            'scrollTop': target.offset().top
          }, 900, 'swing', function () {
            window.location.hash = anchor;
          });
        }
        ;
      });
    }
    ;
  });
};

$(document).ready(function () {
  attachSmoothScroll();
});

$(document).ajaxComplete(function () {
  attachSmoothScroll();
});


